// extracted by mini-css-extract-plugin
module.exports = {"butt":"Button_butt__1_UON","label":"Button_label__3eOF0"};